module.exports = __webpack_public_path__ + "img/webinar_card_image.c53bbca0.png";